export enum FilterControlType {
  SELECT = 'select',
  CHECKBOX = 'checkbox',
  INPUT = 'input',
}
